import Locale from './Locale'
export { Locale }
export default Locale
